<template>
  <v-dialog scrollable persistent
    v-model="config.status.active"
    width="600">
    <Credit v-if="getType === 'credit'"
      ref="credit"
      :closer="true"
      :remover="true"
      @done="finish"
      @close="close"
    />
    <Tutor v-else-if="getType === 'tutor'"
      ref="tutor"
      :closer="true"
      :remover="true"
      @done="finish"
      @close="close"
    />
    <Transfers v-else-if="getType === 'transfers'"
      ref="transfers"
      :closer="true"
      :remover="true"
      @done="finish"
      @close="close"
    />
    <Post v-else
      ref="record"
      :closer="true"
      :remover="true"
      @done="finish"
      @close="close"
    />
  </v-dialog>
</template>

<script>
import Post from '@/components/recorder/post'
import Credit from '@/components/recorder/credit'
import Tutor from '@/components/recorder/tutor'
import Transfers from '@/components/recorder/transfer'
export default {
  name: 'recordsEditor',
  components: {
    Post,
    Credit,
    Tutor,
    Transfers
  },
  data () {
    return {
      config: {
        status: {
          loading: false,
          active: false
        },
        recorder: {
          type: ''
        }
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.$set(this.config.status, 'active', false)
    },
    open: function (item) {
      const { type } = item || {}
      if (type) {
        this.$set(this.config.status, 'active', true)
        this.$set(this.config.recorder, 'type', type)
        this.$nextTick(() => {
          this.$refs[type].init(item)
          this.$emit('opened')
        })
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
      this.$emit('closed')
    },
    finish: function (req) {
      // this.$emit('emit', {
      //   action: 'update',
      //   data: req
      // })
      this.close()
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isActive () {
      return this.config.status.active
    },
    getType () {
      return this.config.recorder.type
    }
  }
}
</script>

<style lang="scss">
</style>
